import { Button, Container, Nav, Navbar } from 'react-bootstrap';

import DwellLogo from '../../../common/components/DwellLogo';

const CandidateNavbarComponent = (props: any) => {
  let content = <></>;
  if (props.connected === false) {
    content = (
      <>
        <Nav className="justify-content-end flex-grow-1">
          <Button className="mb-2 mb-lg-0 mx-lg-4 navbar-button" variant="primary" role="button" href="/login">
            Je suis un agent immobilier
          </Button>
        </Nav>
      </>
    );
  }

  return (
    <>
      <Navbar collapseOnSelect expand="lg" className="navbar-left">
        <Container fluid>
          <div className="p-2">
            <DwellLogo linkTo="/login" />
          </div>
          <Navbar.Toggle className="justify-content-end text-decoration-none" aria-controls="responsive-navbar-nav" />
          <Navbar.Collapse id="responsive-navbar-nav">{content}</Navbar.Collapse>
        </Container>
      </Navbar>
    </>
  );
};

export default CandidateNavbarComponent;
